import { checkOnboardingCompletion } from "./onboardingChecker";

export const ONBOARDING_DASHBOARD_PATH = "/onboarding";
export const CHARITY_CUSTOMIZE_HUB_PATH = `${ONBOARDING_DASHBOARD_PATH}/customize`;

export interface OnboardingStep {
  id: number;
  title: string;
  path: string;
  isComplete: boolean;
}

export const getOnboardingSteps = (
  charityId: string,
  firebaseData: any
): OnboardingStep[] => {
  const completionStatus = checkOnboardingCompletion(charityId, firebaseData);
  
  return [
    {
      id: 1,
      title: "Set Up Organization",
      path: ONBOARDING_DASHBOARD_PATH,
      isComplete: completionStatus.completedTasks.organization,
    },
    {
      id: 2,
      title: "Set Up Stripe",
      path: ONBOARDING_DASHBOARD_PATH,
      isComplete: completionStatus.completedTasks.payment,
    },
    {
      id: 3,
      title: "Set Up Email",
      path: ONBOARDING_DASHBOARD_PATH,
      isComplete: completionStatus.completedTasks.domain,
    },
    {
      id: 4,
      title: "Set Up Branding",
      path: ONBOARDING_DASHBOARD_PATH,
      isComplete: completionStatus.completedTasks.branding,
    },
  ];
};

export const getFirstIncompleteStep = (
  charityId: string,
  firebaseData: any
): OnboardingStep | null => {
  const steps = getOnboardingSteps(charityId, firebaseData);
  return steps.find(step => !step.isComplete) || null;
};